import { useContext } from 'react';
import ModuleContext from '../pages/material/_contexts/ModuleContext';
import IdentityContext from '../contexts/IdentityContext';

export default function useModuleLicenseCheck() {
  const { module } = useContext(ModuleContext);
  const {
    identity: { isTeacherAlike },
  } = useContext(IdentityContext);

  const isTeacherWithLicense = module && isTeacherAlike && module.licenses.hasDocumentLicenseForTeacher;
  const isStudentWithLicense = module && !isTeacherAlike && module.licenses.hasDocumentLicenseForStudent;

  return {
    isUserLicensed: isTeacherWithLicense || isStudentWithLicense,
  };
}
